import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ScanFace } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("admin_token", data.token);
      nav("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative bg-zinc-900">
        <img src="https://images.unsplash.com/photo-1777788613992-5f2655a97e72?w=1400&q=80" alt="" className="absolute inset-0 w-full h-full object-cover opacity-60" />
        <div className="absolute bottom-10 left-10 text-white max-w-sm">
          <h2 className="font-display font-black text-4xl tracking-tighter">Área do fotógrafo</h2>
          <p className="mt-2 text-white/80">Crie eventos, envie fotos e acompanhe suas vendas.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
          <Link to="/" className="flex items-center gap-2 mb-10">
            <span className="w-8 h-8 bg-[#0055FF] text-white grid place-items-center rounded-md"><ScanFace className="w-5 h-5" /></span>
            <span className="font-display font-extrabold text-xl">GO-CLICK</span>
          </Link>
          <h1 className="font-display font-bold text-3xl tracking-tight">Entrar</h1>
          <label className="block mt-8 text-sm font-medium">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" className="mt-1 w-full h-12 px-3 rounded-md border border-zinc-200 focus:outline-none focus:ring-2 focus:ring-[#0055FF]" />
          <label className="block mt-4 text-sm font-medium">Senha</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" className="mt-1 w-full h-12 px-3 rounded-md border border-zinc-200 focus:outline-none focus:ring-2 focus:ring-[#0055FF]" />
          {error && <p className="mt-3 text-sm text-red-500" data-testid="login-error">{error}</p>}
          <button disabled={loading} data-testid="login-submit-btn" className="mt-6 w-full h-12 rounded-md bg-[#0055FF] hover:bg-[#0040CC] disabled:opacity-60 text-white font-semibold transition-colors">
            {loading ? "Entrando…" : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
